import BirthYearSection from './BirthYearSection/BirthYearSection';
import { FantasySection } from './FantasySection/FantasySection';
import { FriendSection } from './FriendSection/FriendSection';
import Header from './Header/Header';
import { KnowledgeMapSection } from './KnowledgeMapSection/KnowledgeMapSection';
import { LessonSection } from './LessonSection/LessonSection';
import LexiSection from './LexiSection/LexiSection';
import PersonaliseSection from './PersonaliseSection/PersonaliseSection';
import ProgressHeader from './ProgressHeader/ProgressHeader';
import { ReviewSection } from './ReviewSection/ReviewSection';
import { ScenarioSection } from './ScenarioSection/ScenarioSection';
import { WordListSection } from './WordListSection/WordListSection';
const HomePage = () => {
    return (
        <div>
            <Header />
            <ProgressHeader />
            <BirthYearSection />
            <PersonaliseSection />
            <ReviewSection />
            <KnowledgeMapSection />
            <LexiSection />
            <FantasySection />
            <LessonSection />
            <WordListSection />
            <FriendSection />
            <ScenarioSection />
        </div>
    );
};

export default HomePage;
